/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IAvailabilityBlockData } from './availability-block.data';
import { IAvailabilityBlockProps } from './availability-block.props.autogenerated';

export interface IAvailabilityBlockViewProps extends IAvailabilityBlockProps<IAvailabilityBlockData> {
    name: string;
    siteImageUrl: string;
    siteImageAlt: string;
    link: string;
}

/**
 *
 * AvailabilityBlock component
 * @extends {React.PureComponent<IAvailabilityBlockProps<IAvailabilityBlockData>>}
 */
class AvailabilityBlock extends React.PureComponent<IAvailabilityBlockProps<IAvailabilityBlockData>> {
    public render(): JSX.Element | null {

        const AvailabilityBlockViewProps = {
            ...this.props,
            name: this.props.config.availName ? this.props.config.availName : 'Product not available',
            siteImageUrl: this.props.config.siteImage ? this.props.config.siteImage.src : '',
            siteImageAlt: this.props.config.siteImage ? this.props.config.siteImage.altText : '',
            link: this.props.config.siteLink ? this.props.config.siteLink : ''
        };

        return this.props.renderView(AvailabilityBlockViewProps);
    }
}

export default AvailabilityBlock;
